import { get } from 'lodash'
import { required } from 'utils/validation'

const validate = values => {
  let errors = {}

  const noPartOfGOP = get(values, 'noPartOfGOP')

    errors = {
    countryId: required(get(values, 'countryId')),
    operatingAuthorityId: required(get(values, 'operatingAuthorityId')),
    subOperatingAuthorityId: required(get(values, 'subOperatingAuthorityId'))
  }

  if (!noPartOfGOP) {
    errors.globalOperatingPartnerId = required(get(values, 'globalOperatingPartnerId'))
    const subGopList = get(values, 'helpers.subGlobalOperatingPartners')

    if (subGopList && subGopList.length > 0) {
      errors.subGlobalOperatingPartnerId = required(get(values, 'subGlobalOperatingPartnerId'))
    }
  }

  return errors
}

export default validate
